// @flow

import React from 'react';
import PropTypes from 'prop-types';

import { Typography } from '@material-ui/core';

import { LineCMS } from '../../../data/cms/types/common';

import './style.css';

type Props = {
    Content: LineCMS
};

function Info(props: Props) {
    const { Content } = props;

    return (
        <Typography component="div" className="support-info">
            <Typography component="h1" className="first-line">
                {Content.Line1}
            </Typography>
            <Typography component="h1" className="second-line">
                {Content.Line2}
            </Typography>
        </Typography>
    );
}

Info.propTypes = {
    Content: PropTypes.any.isRequired
};

export default Info;
